// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"71":"hotel-reviews","320":"sustainability","400":"map-content-resort","412":"hotel-info"}[chunkId] + "." + __webpack_require__.h() + ".css";
};